export default __webpack_public_path__ + "static/media/icon-diestruck.e4bb6e62.svg";